module.exports = __webpack_public_path__ + "img/CITIBANK.b6aa856f.svg";